/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Privacylist_Unsubscribe1Inputs */

const id_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda dapat berhenti berlangganan kapan saja`)
};

const ms_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda boleh berhenti melanggan pada bila-bila masa`)
};

const da_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan afmelde til enhver tid`)
};

const de_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie können jederzeit kündigen`)
};

const en_us2_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can unsubscribe at any time`)
};

const es_es2_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes cancelar la suscripción en cualquier momento`)
};

const es_mx2_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes cancelar la suscripción en cualquier momento`)
};

const fil_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maaari kang mag-unsubscribe anumang oras`)
};

const fr_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez vous désabonner à tout moment`)
};

const it_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi annullare l'iscrizione in qualsiasi momento`)
};

const hu_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bármikor leiratkozhatsz`)
};

const nl_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt op elk moment uitschrijven`)
};

const no_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan melde deg av når som helst`)
};

const pl_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Możesz wypisać się w dowolnym momencie`)
};

const pt_br2_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pode cancelar a assinatura a qualquer momento`)
};

const pt_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode cancelar a subscrição em qualquer momento`)
};

const ro_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te poți dezabona oricând`)
};

const fi_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voit peruuttaa tilauksen milloin tahansa`)
};

const sv_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan avsluta prenumerationen när som helst`)
};

const vi_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn có thể hủy đăng ký bất kỳ lúc nào`)
};

const tr_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstediğiniz zaman aboneliğinizi iptal edebilirsiniz`)
};

const cs_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odběr můžete kdykoli zrušit`)
};

const bg_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Можете да се отпишете по всяко време`)
};

const ru_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете отписаться в любое время`)
};

const uk_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви можете відписатися в будь-який час`)
};

const ar_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكنك إلغاء الاشتراك في أي وقت`)
};

const hi_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप किसी भी समय सदस्यता रद्द कर सकते हैं`)
};

const th_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสามารถยกเลิกการสมัครได้ตลอดเวลา`)
};

const ja_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつでも購読を解除できます`)
};

const zh_cn2_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您可以随时取消订阅`)
};

const zh_hant1_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您可以隨時取消訂閱`)
};

const ko_notifications_privacylist_unsubscribe1 = /** @type {(inputs: Notifications_Privacylist_Unsubscribe1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언제든지 구독을 취소할 수 있습니다`)
};

/**
* | output |
* | --- |
* | "You can unsubscribe at any time" |
*
* @param {Notifications_Privacylist_Unsubscribe1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_privacylist_unsubscribe1 = /** @type {((inputs?: Notifications_Privacylist_Unsubscribe1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Privacylist_Unsubscribe1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "ms") return ms_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "da") return da_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "de") return de_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "en-US") return en_us2_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "es-ES") return es_es2_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "fil") return fil_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "fr") return fr_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "it") return it_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "hu") return hu_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "nl") return nl_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "no") return no_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "pl") return pl_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "pt") return pt_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "ro") return ro_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "fi") return fi_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "sv") return sv_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "vi") return vi_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "tr") return tr_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "cs") return cs_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "bg") return bg_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "ru") return ru_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "uk") return uk_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "ar") return ar_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "hi") return hi_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "th") return th_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "ja") return ja_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_privacylist_unsubscribe1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_privacylist_unsubscribe1(inputs)
	return ko_notifications_privacylist_unsubscribe1(inputs)
});
export { notifications_privacylist_unsubscribe1 as "notifications.privacyList.unsubscribe" }